import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { WA_LINK, WA_DISPLAY } from "@/lib/constants";

export default function FinalCTA() {
  return (
    <section id="kontak" data-testid="final-cta-section" className="relative py-28 lg:py-48 border-t border-ink/10 overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[500px] w-[700px] ice-glow -z-10" />
      <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="font-display font-extrabold uppercase tracking-tight leading-[0.92] text-[13vw] sm:text-7xl lg:text-8xl xl:text-9xl"
        >
          Siap
          <br />
          <span className="text-brand-ink">Membantu?</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="mx-auto mt-8 max-w-lg text-base md:text-lg text-ink/55 leading-relaxed"
        >
          Jangan biarkan mesin rusak mengganggu hari Anda. Satu chat, teknisi kami langsung dijadwalkan.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.25 }}
          className="mt-12"
        >
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-whatsapp-button"
            aria-label="Booking service via WhatsApp sekarang"
            className="group inline-flex items-center gap-4 rounded-full bg-brand px-10 py-5 lg:px-14 lg:py-7 font-display font-extrabold text-black text-lg lg:text-2xl hover:bg-ink hover:text-white transition-colors duration-300"
          >
            Booking via WhatsApp
            <ArrowUpRight className="h-6 w-6 lg:h-8 lg:w-8 transition-transform duration-300 group-hover:rotate-45" />
          </a>
          <p className="mt-6 font-mono text-xs uppercase tracking-[0.25em] text-ink/45">
            WhatsApp: {WA_DISPLAY}
          </p>
        </motion.div>
      </div>
    </section>
  );
}
